package br.com.htms.inspeccaocampo.platform

/**
 * Recorte da tinta da assinatura (remove margem em branco do pad).
 * Usado pelos encodeSignature* para o desenho ocupar a caixa no PDF.
 */
internal object SignatureInkBounds {
    data class Box(
        val minX: Float,
        val minY: Float,
        val maxX: Float,
        val maxY: Float
    ) {
        val width: Float get() = (maxX - minX).coerceAtLeast(1f)
        val height: Float get() = (maxY - minY).coerceAtLeast(1f)
    }

    fun of(
        strokes: List<List<Pair<Float, Float>>>,
        canvasW: Int,
        canvasH: Int,
        pad: Float = 18f
    ): Box? {
        var minX = Float.POSITIVE_INFINITY
        var minY = Float.POSITIVE_INFINITY
        var maxX = Float.NEGATIVE_INFINITY
        var maxY = Float.NEGATIVE_INFINITY
        var any = false
        strokes.forEach { stroke ->
            stroke.forEach { (x, y) ->
                any = true
                if (x < minX) minX = x
                if (y < minY) minY = y
                if (x > maxX) maxX = x
                if (y > maxY) maxY = y
            }
        }
        if (!any) return null
        return Box(
            minX = (minX - pad).coerceAtLeast(0f),
            minY = (minY - pad).coerceAtLeast(0f),
            maxX = (maxX + pad).coerceAtMost(canvasW.toFloat()),
            maxY = (maxY + pad).coerceAtMost(canvasH.toFloat())
        )
    }
}
